export default "__VITE_ASSET__BlcAusrk__"